import { render, staticRenderFns } from "./FaqFeedback.vue?vue&type=template&id=67ee5738"
import script from "./FaqFeedback.vue?vue&type=script&lang=js"
export * from "./FaqFeedback.vue?vue&type=script&lang=js"
import style0 from "./FaqFeedback.vue?vue&type=style&index=0&id=67ee5738&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports